module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_integration03-c95714cd9895cb2549b35379fc211354.png";